import DataTable from "../../../components/Table";
import type { ColumnsType } from "antd/es/table";
import { Row, Col, Button, Space, Popconfirm, message } from "antd";
import { DeleteOutlined } from "@ant-design/icons";
import CategorySearch from "./CategorySearch";
import { useEffect, useState } from "react";
import { useAppDispatch, useAppSelector } from "../../../redux/hooks";
import { fetchCategory } from "../../../redux/slice/categorySlice";
import AddCategory from "./add";
import { callDeleteCategory } from "../../../config/api";
import ModalCategory from "./edit";
import DateFormat from "../../../utils/formatTime/DateFormat";
import { FORMAT_DATE_DISPLAY } from "../../../utils/constants/timeFormat";
import ViewDetail from "./detail/ViewDetail";

interface DataType {
  key: React.Key;
  idTopic: string;
  idCategory: string;
  description: string;
  image: string;
}
function ManageCategory() {
  const [searchPagination, setSearchPagination] = useState(
    "current=1&pageSize=5"
  );
  const [searchData, setSearchData] = useState("");
  const dispatch = useAppDispatch();
  const categories = useAppSelector((state) => state.category);
  const [dataViewDetail, setDataViewDetail] = useState("");
  const [openViewDetail, setOpenViewDetail] = useState(false);

  const columns: ColumnsType<DataType> = [
    {
      title: "ID",
      dataIndex: "_id",
      render: (text, record: any) => {
        return (
          <span
            style={{ color: "#4986ff", cursor: "pointer" }}
            onClick={() => {
              setDataViewDetail(record);
              setOpenViewDetail(true);
            }}>
            {text}
          </span>
        );
      },
    },
    {
      title: "Name",
      dataIndex: "name",
    },
    // {
    //   title: "Description",
    //   dataIndex: "description",
    //   render: (text) => {
    //     const slicedText = text?.slice(0, 50);
    //     let newText = slicedText?.length >= 50 ? `${slicedText}...` : text;
    //     return <span style={{ color: "#1677ff" }}>{newText}</span>;
    //   },
    // },
    {
      title: "CreatedAt",
      dataIndex: "createdAt",
      render: (text) => {
        return (
          <>
            <DateFormat time={text} format={FORMAT_DATE_DISPLAY} />
          </>
        );
      },
    },
    {
      title: "UpdatedAt",
      dataIndex: "updatedAt",
      render: (text) => {
        return (
          <>
            <DateFormat time={text} format={FORMAT_DATE_DISPLAY} />
          </>
        );
      },
    },
    {
      title: "Action",
      key: "action",
      render: (_, record: any) => (
        <Space size="middle">
          <ModalCategory
            id={record._id}
            handleFetchCategory={handleFetchCategory}
          />
          <Popconfirm
            placement="leftTop"
            title={"Xác nhận xóa user"}
            description={"Bạn có chắc chắn muốn xóa user này ?"}
            onConfirm={() => handleDeleteCategory(record._id)}
            okText="Xác nhận"
            cancelText="Hủy">
            <Button type="primary" danger ghost>
              <DeleteOutlined />
            </Button>
          </Popconfirm>
        </Space>
      ),
    },
  ];

  let query = `${searchPagination}${searchData}`;

  const handleDeleteCategory = async (id: string) => {
    const result = await callDeleteCategory(id);
    if (result.statusCode === 200) {
      handleFetchCategory();
      message.success("delete success!");
    } else {
      message.error("delete failed!");
    }
  };

  const handleFetchCategory = () => {
    dispatch(fetchCategory({ query }));
  };
  useEffect(() => {
    handleFetchCategory();
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [query]);

  const handleModalCreate = (): JSX.Element => {
    return (
      <>
        <AddCategory handleFetchCategory={handleFetchCategory} />
      </>
    );
  };

  const handleSearch = (paramSearch: any) => {
    setSearchData(paramSearch);
  };

  return (
    <>
      <Row gutter={[20, 20]}>
        <Col span={24}>
          <CategorySearch handleSearch={handleSearch} />
        </Col>
      </Row>
      <DataTable
        columns={columns}
        data={categories?.result}
        loading={categories.isFetching}
        total={categories?.meta.total}
        modalAdd={handleModalCreate}
        name={"Categories"}
        setSearchPagination={setSearchPagination}
      />
      <ViewDetail
        openViewDetail={openViewDetail}
        dataViewDetail={dataViewDetail}
        setOpenViewDetail={setOpenViewDetail}
      />
    </>
  );
}

export default ManageCategory;
